import React from "react";

import theme from "config/theme";

import Slider, { ArrowButton } from "components/Slider";
import { IntroBlock } from "components/Block";
import Grid, { Container } from "components/Grid";

import Step from "./Step";

import { Inner } from "./styles";

const Process = ({ content, ...props }) => {
  const settings = {
    dots: false,
    speed: 300,
    infinite: false,
    slidesToShow: 4,
    nextArrow: <ArrowButton type="next" shade="dark" />,
    prevArrow: <ArrowButton type="previous" shade="dark" />,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <Container
      bg={theme.color.paper2}
      pt={["40px", "80px"]}
      zIndex="0"
      position="static"
    >
      <Grid>
        <IntroBlock px="20px" content={content} />
      </Grid>
      <Inner>
        <Slider {...settings}>
          {content.steps.map((step, index) => (
            <Step key={index} content={step} count={index + 1} {...settings} />
          ))}
        </Slider>
      </Inner>
    </Container>
  );
};

export default Process;
